import { apiSlice } from '../../api/slice'

export const memecoinsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMemecoin: builder.mutation({
      query: (data) => ({
        url: `/memecoins/create`,
        method: 'POST',
        body: data,
      }),
    }),
    createMemecoinComment: builder.mutation({
      query: ({ data }) => ({
        url: `/memecoins/comment/create`,
        method: 'POST',
        body: data,
      }),
    }),
    createMemecoinReply: builder.mutation({
      query: ({ data }) => ({
        url: `/memecoins/comment/reply/create`,
        method: 'POST',
        body: data,
      }),
    }),
    addMemecoinCommentReaction: builder.mutation({
      query: ({ data }) => ({
        url: `/memecoins/comment/add-reaction`,
        method: 'PUT',
        body: data,
      }),
    }),
    addMemecoinCommentReplyReaction: builder.mutation({
      query: ({ data }) => ({
        url: `/memecoins/comment/reply/add-reaction`,
        method: 'PUT',
        body: data,
      }),
    }),
    getMemecoins: builder.query({
      query: ({
        offset = 0,
        limit = 20,
        search = '',
        filter = 'trending',
      }) => ({
        url: `/memecoins?offset=${offset}&limit=${limit}&filter=${filter}&search=${search}`,
      }),
    }),
    getMemecoinByAddress: builder.query({
      query: ({ address }) => ({
        url: `/memecoins/address/${address}`,
      }),
    }),
    getMemecoinTransactionsByAddress: builder.query({
      query: ({ address, ordering, limit, offset, search }) => ({
        url: `/memecoins/address/${address}/transactions`,
        params: {
          ordering,
          limit,
          offset,
          search,
        },
      }),
    }),
    getMemecoinTransactionsByAddressDateRange: builder.query({
      query: ({ address, from, to }) => ({
        url: `/memecoins/address/${address}/transactions/date-range`,
        params: {
          from,
          to,
        },
      }),
    }),
    getMemecoinInfluencersByAddress: builder.query({
      query: ({ address }) => ({
        url: `/memecoins/address/${address}/influencers`,
      }),
    }),
    getMemecoinCommentsByAddress: builder.query({
      query: ({ address }) => ({
        url: `/memecoins/address/${address}/comments`,
      }),
    }),
    getMemecoinsMostRecentUpdates: builder.query({
      query: () => ({
        url: `/memecoins/most-recent-updates`,
      }),
    }),
    getMemecoinPrimePick: builder.query({
      query: () => ({
        url: `/memecoins/prime-pick`,
      }),
    }),
    getMemecoinsHeld: builder.query({
      query: ({ limit, offset, search = '' }) => ({
        url: `/memecoins/held?limit=${limit}&offset=${offset}&search=${search}`,
      })
    }),
    getMemecoinsCreatedByUser: builder.query({
      query: () => ({
        url: `/memecoins/created`,
      })
    }),
    getMemecoinUserTransactions: builder.query({
      query: ({ address }) => ({
        url: `/memecoins/user-transactions/${address}`,
      }),
    }),
    get24HEthVolumeEthByAddress: builder.query({
      query: ({ address }) => ({
        url: `/memecoins/eth-volume/${address}`,
      }),
    })
  }),
})

export const {
  useCreateMemecoinMutation,
  useCreateMemecoinCommentMutation,
  useCreateMemecoinReplyMutation,
  useAddMemecoinCommentReactionMutation,
  useAddMemecoinCommentReplyReactionMutation,
  useGetMemecoinsQuery,
  useLazyGetMemecoinsQuery,
  useGetMemecoinByAddressQuery,
  useLazyGetMemecoinByAddressQuery,
  useGetMemecoinTransactionsByAddressQuery,
  useGetMemecoinTransactionsByAddressDateRangeQuery,
  useLazyGetMemecoinTransactionsByAddressDateRangeQuery,
  useLazyGetMemecoinTransactionsByAddressQuery,
  useGetMemecoinInfluencersByAddressQuery,
  useLazyGetMemecoinInfluencersByAddressQuery,
  useGetMemecoinCommentsByAddressQuery,
  useLazyGetMemecoinCommentsByAddressQuery,
  useGetMemecoinsMostRecentUpdatesQuery,
  useLazyGetMemecoinsMostRecentUpdatesQuery,
  useGetMemecoinPrimePickQuery,
  useLazyGetMemecoinPrimePickQuery,
  useGetMemecoinsHeldQuery,
  useLazyGetMemecoinsHeldQuery,
  useGetMemecoinsCreatedByUserQuery,
  useLazyGetMemecoinsCreatedByUserQuery,
  useGetMemecoinUserTransactionsQuery,
  useLazyGetMemecoinUserTransactionsQuery,
  useGet24HEthVolumeEthByAddressQuery,
  useLazyGet24HEthVolumeEthByAddressQuery,
} = memecoinsApiSlice
